import * as React from "react";
import { Controller } from "react-hook-form";
import axios from "axios";
import { Label } from "../../../components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectLabel,
  SelectGroup,
} from "../../../components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { FieldError } from "./FieldError";

export function DropdownInput({
  control,
  label,
  dropdownLabel,
  stepName,
  stepId,
  itemList,
  disabled,
  validate
}) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [validating, setValidating] = React.useState(false);
  const [selectKey, setSelectKey] = React.useState(0);

  return (
    <div className="space-y-2">
      <Label>{label}</Label>

      <Controller
        control={control}
        name={stepName}
        render={({ field }) => {
          const handleValueChange = async (v) => {
            if (disabled) return;
            try {
              if (validate) {
                setValidating(true);
                const res = await validate(v);
                // If NOT found => block + reset Select’s internal UI
                if (res.status === 404) {
                  setDialogOpen(true);
                  setSelectKey((k) => k + 1); // ⟵ clears the temporary visual selection
                  return;
                }
  
                if (res.status < 200 || res.status >= 300) {
                  setDialogOpen(true);
                  setSelectKey((k) => k + 1);
                  return;
                }
              }


              // Valid -> commit
              field.onChange(v);
            } catch (err) {
              // Network/unknown errors or axios with .response?.status
              if (err?.response?.status === 404) {
                setDialogOpen(true);
              } else {
                setDialogOpen(true);
              }
              setSelectKey((k) => k + 1);
            } finally {
              setValidating(false);
            }
          };

          return (
            <Select
              key={selectKey}
              disabled={disabled || validating}
              value={field.value === 'na' ? undefined : field.value}
              onValueChange={handleValueChange}
            >
              <SelectTrigger className="w-full !h-10 py-2 px-3" onBlur={() => field.onChange(field.value)}>
                <SelectValue placeholder={validating ? "Validating..." : "Select"} />
              </SelectTrigger>
              <SelectContent className="max-h-60 overflow-y-auto">
                <SelectGroup>
                  <SelectLabel>{dropdownLabel}</SelectLabel>
                  {itemList.map((s) => (
                    <SelectItem key={s.value} value={s.value}>
                      {s.label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          );
        }}
      />

      <FieldError name={stepName} step={stepId} />

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>State License Invalid</DialogTitle>
            <DialogDescription>
              Agency&apos;s state license must be current and valid.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={() => setDialogOpen(false)}>OK</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
